export const ACTIVITY_BAR_SIZE = 20
export const MINIATURE_BAR_SIZE = 9
export const MINIATURE_AREA_WIDTH = 12

// Helper to measure text width
export function getTextWidth(text: string, font = "16px Inter, sans-serif") {
  // Create a canvas for measuring text
  const canvas = document.createElement("canvas")
  const context = canvas.getContext("2d")
  if (!context) return 0
  context.font = font
  return context.measureText(text).width + 20
}
